import React from 'react';

const MapOverlay = ({ label }) => {
  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      backgroundColor: '#44444459'
    },
    label: {
      fontSize: '16px',
      fontWeight: 'bold',
      fontSize: "20px",
      fontWeight: "bold",
      padding: "10px",
      color: "white"
    }
  };

  return (
    <div style={styles.container}>
      <span style={styles.label}>{label}</span>
    </div>
  );
};

export default MapOverlay;
